import React, {useState} from 'react'
import styled from 'styled-components'
import { userInfoProps } from '../../../constants/usercenter'
import CopyToClipboard from 'react-copy-to-clipboard'
import { dealToken } from '../../../utils/func'
import { Usertip } from '../../../components/Tooltip'
import useParsedQueryString from '../../../hooks/useParsedQueryString'
import { useHistory } from 'react-router-dom';
import { useActiveWeb3React } from '../../../hooks'

const OverviewWrapper = styled.div`
  width: 100%;
  position: relative;
  margin-top: 20px;
`

const UserName = styled.div`
  font-family: Roboto, 'Libre Franklin', 'Roboto-Regular';
  font-style: normal;
  font-weight: bold;
  font-size: 40px;
  line-height: 105.9%;
  letter-spacing: 0.02em;
  color: ${({ theme }) => theme.bsText22};
`
const UserBrief = styled.div`
  font-family: Roboto, 'Libre Franklin', 'Roboto-Regular';
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 125.9%;
  letter-spacing: 0.02em;
  color:  ${({ theme }) => theme.bsText22};
  opacity: 0.8;
  margin-top: 8px;
  word-break: break-all;
`
const UserDetail = styled.div`
  font-family: Roboto, 'Libre Franklin', 'Roboto-Regular';
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 105.9%;
  display: flex;
  align-items: center;
  letter-spacing: 0.02em;
  color: ${({ theme }) => theme.bsText22};
  margin-top: 24px;
`
const UserAddress = styled.div`
  margin-right: 8px;
  word-break: break-all;
`

const UserLink = styled.a`
  margin-left: 24px;
  padding-left: 24px;
  border-left: 1px solid rgba(177, 177, 177, 0.41);
  max-width: 500px;
  word-break: break-all;
  cursor: pointer;
  color: inherit;
  text-decoration: none;
  &:hover{
    text-decoration: underline;
  }
`
const IconLink = styled.img`
  width: 13px;
  height: 13px;
  margin-left: 9px;
`

const ButtonEdit = styled.div`
  right: 0px;
  top: 0px;
  position: absolute;
  cursor: pointer;
`

export default function Overview({info, owner}: {info: userInfoProps, owner: string} ) {
  const query = useParsedQueryString()
  const history = useHistory()
  const { account } = useActiveWeb3React()

  const [show, setShow] = useState(false)
  const copy = () => {
    setShow(true)
    setTimeout(() => {
      setShow(false)
    }, 1000)
  }
  const jump = () => {
    const hrefs = window.location.href.split("/")
    const urlAddress = hrefs[hrefs.length - 1].split("?")[0]

    if (query.hasOwnProperty('artist') && query.artist) {
      if(info.address){
        history.push(`/personalInfo/${info.address}?artist=${query.artist}`)
      }else{
        history.push(`/personalInfo/${urlAddress}?artist=${query.artist}`)
      }
    } else {
      if(info.address){
        history.push(`/personalInfo/${info.address}`)
      }else{
        history.push(`/personalInfo/${urlAddress}`)
      }
    }
  }
  return (
    <OverviewWrapper>
      <UserName>{info.nick}</UserName>
      <UserBrief>{info.introduction}</UserBrief>
      <UserDetail>
        <UserAddress>{ dealToken(owner, '**********') }</UserAddress>
        <Usertip text={'success!'} show={show} width={90} fontSize={'14px'} placement='top'>
          <CopyToClipboard 
            text={info.address}
            onCopy={copy}
          >
            <img src="/images/user/icon_copy2.svg" alt="" style={{cursor: 'pointer'}}/> 
          </CopyToClipboard>
        </Usertip>
        {
          info.link && (
            <>
              <UserLink href={info.link} target="_blank">{info.link}</UserLink>
              <IconLink src="/images/user/icon_link.svg"/>
            </>
          )
        }
      </UserDetail>
      {
        account && owner === account && (
          <ButtonEdit onClick={jump}>
            <img src="/images/user/icon_edit.svg" alt=""/>
          </ButtonEdit>
        )
      }
    </OverviewWrapper>
  )
}
